import React, { useEffect, useState } from "react";

// Decorative looping video used as a section's background plate.
// Visitors who prefer reduced motion get the still poster frame instead.
const SceneVideo = ({ src, poster, className = "" }) => {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduceMotion(mq.matches);
    const onChange = (e) => setReduceMotion(e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return (
    <video
      key={reduceMotion ? "still" : "motion"}
      className={`scene-video ${className}`}
      src={src}
      poster={poster}
      autoPlay={!reduceMotion}
      loop
      muted
      playsInline
      preload={reduceMotion ? "none" : "auto"}
      aria-hidden="true"
      tabIndex={-1}
    />
  );
};

export default SceneVideo;
